export const isLiveEnv =
  process.env.NEXT_PUBLIC_CHAMPAIGN_API_HOST?.includes("actions.eko.org");

export const currentEnv = isLiveEnv ? "prod" : "dev";
